'use client';

import { LoginButton } from '@telegram-auth/react';
import { env } from '~/env';
import { useTelegramLogin } from '../model/mutations';

export default () => {
    const { mutate: onTelegramSubmit } = useTelegramLogin();

    return (
        <LoginButton
            botUsername={env.NEXT_PUBLIC_TELEGRAM_BOT}
            buttonSize='large'
            lang='ru'
            onAuthCallback={onTelegramSubmit}
        />
    );
};
